export default __webpack_public_path__ + "static/media/role-edit-icon.640d349e.svg";